import {ReactNode} from "react";
import {useEventListener} from "usehooks-ts";
import {q, useQueryData} from "../state/index.ts";
import api from "../api/index.ts";
import {isPlatformedUser} from "../utils/owners.ts";
import {clearAllAccountLocalStates} from "../hooks/accountLocalState";
import {toaster} from "./ui/toaster";

export function InternalModeProvider({children}: {children?: ReactNode}) {
  const whoami = useQueryData(q.whoAmI());
  useEventListener("keydown", async e => {
    if (e.key === "`" && e.ctrlKey) {
      await api.auth.updateInternalMode(!whoami.internal_mode);
      if (whoami.internal_mode) {
        clearAllAccountLocalStates("questionLayerType");
      }
      toaster.warning({description: `Internal mode: ${whoami.internal_mode ? "Disabled" : "Enabled"}`});
    }
  });
  return children;
}

export function Platformed({children}: {children?: ReactNode}) {
  const whoami = useQueryData(q.whoAmI());
  if (isPlatformedUser(whoami.user)) {
    return children;
  } else {
    return [];
  }
}

export function Internal({children}: {children?: ReactNode}) {
  const whoami = useQueryData(q.whoAmI());
  if (whoami.internal_mode) {
    return children;
  } else {
    return [];
  }
}
